import React, { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import '../../styles.css'
import log from "../../images/logo/logo9.png"
import br from "../../images/br.png"
import us from "../../images/usa.png"
import esp from "../../images/esp.png"

function CustomNavbar() {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };


  return (
    <Navbar bg="dark" variant="dark" expand="lg" expanded={expanded}>
      <Container>
        <Navbar.Brand href="/"><img src={log} alt="" class="logohead"/></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
          <div style={{ display: 'flex', justifyContent: 'left'}}>
          <Nav.Link href="/" style={{width: '60px', margin: '0'}}>
            <img src={br} className="pt" alt=""/>
            </Nav.Link>
            <Nav.Link href="/en" style={{width: '60px', margin: '0'}}>
            <img src={us} className="en" alt=""/>
          </Nav.Link>
          <Nav.Link href="/es" style={{width: '60px', margin: '0'}}>
            <img src={esp} className="es" alt=""/>
          </Nav.Link>
          </div>
          <Nav.Link href="/produtos" className="links">Produtos</Nav.Link>
            <Nav.Link href="/sobre" className="links">Sobre nós</Nav.Link>
            <Nav.Link href="/contato" className="links">Contato</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
      );
}

export default CustomNavbar;
